module.exports = __webpack_public_path__ + "img/donation-bg.cc878f2b.jpg";